import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Log Core Web Vitals in development; in production these could be sent to
// an analytics endpoint instead.
if (process.env.NODE_ENV === 'development') {
  reportWebVitals(console.log);
}
